const proxyURL = '/.netlify/functions/api-proxy';

// Helper function to make proxy requests
const makeProxyRequest = async (endpoint: string, method: string = 'GET', data?: any, userToken: string = '', authUserId?: string) => {
  const requestBody = {
    endpoint,
    method,
    data,
    userToken,
    authUserId,
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody)
  };

  return fetch(proxyURL, requestOptions);
};

export const fetchReferrals = async (authUserId: string, userToken: string = '') => {
  const endpoint = `api/memeverse/referral_data?user_id=${authUserId}`;
  return makeProxyRequest(endpoint, 'GET', undefined, userToken, authUserId);
}

export const sendReferralEmail = async (
  authUserId: string,
  targetEmail: string,
  userToken: string = ''
) => {
  const data = {
    user_id: authUserId,
    email: targetEmail,
  };

  return makeProxyRequest('api/memeverse/send_referral_email', 'POST', data, userToken, authUserId);
}

// Helper functions
export const isValidEmail: (email: string) => boolean = (email: string) => {
  return !!email && !!(email.toLowerCase()
  .match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  ));
}

export const handleSendReferralEmail = async (
  authUser: any,
  email: string,
  refetch: any,
  toast: any,
  inputRef?: any,
  userToken: string = ''
) => {
  if (isValidEmail(email)) {
    return sendReferralEmail(authUser.uid, email, userToken)
    .then((resp) => {
      if (resp.ok) {
        if (toast) toast.success("Invite sent successfully")
        if (refetch) refetch()
        if (inputRef) inputRef.current.value = '';
      } else {
        if (toast) toast.error("Error sending invite")
      }
    }
    ).catch((error) => {
      console.log(error)
      if (toast) toast.error("Error sending invite")
    })
  }
}
